import { Accordion } from "@/components/General/Faq/components/accordion/accordion";
import { AccordionItem } from "@/components/General/Faq/components/accordion/accordionItem";
import { Answer } from "@/components/General/Faq/components/accordion/answer";
import { Question } from "@/components/General/Faq/components/accordion/question";
import { Categories } from "@/components/General/Faq/components/categories/categories";
import { CategoryButton } from "@/components/General/Faq/components/categories/categoryButton";
import { Base } from "@/components/General/Faq/faq.base";

export const Faq = Object.assign(Base, {
    Accordion: Object.assign(Accordion, {
        Item: Object.assign(AccordionItem, {
            Question: Question,
            Answer: Answer
        })
    }),
    Categories: Object.assign(Categories, {
        Button: CategoryButton
    })
});
